import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseChartDirective, Color } from 'ng2-charts';

declare var global: any;
var Color = global.Color;

@Component({
  selector: 'app-compare-source',
  templateUrl: './compare-source.component.html',
  styleUrls: ['./compare-source.component.scss']
})
export class CompareSource implements OnInit {

  @Input() dataReport: any
  title_report = 'SO SÁNH NGUỒN BÀI ĐĂNG';  

  @ViewChild('mainBarChart') mainBarChart: BaseChartDirective;
  public barChartData: any;
  public barChartLabels: string[] = [];
  public barChartLegend = true;
  public barChartType = 'bar';
  public barChartOptions: any = {
    // scaleShowVerticalLines: false,
    // responsive: false
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
    plugins: {
      labels: false
    },
    scales: {
      xAxes: [{
        display: true,
        stacked: true,
        barPercentage: 0.6,
        ticks: {
          beginAtZero: true
        },
        distribution: 'series',
        // type: 'time',
        time: {
          displayFormats: {
            quarter: 'MMM DD'
          },
          // unit: 'hour'
        }
      }],
      responsive: true,
      yAxes: [{
        stacked: true,
        display: true,
        ticks: {
          beginAtZero: true,
          callback: function(value) {
              return value + "%"
          }
        },
        scaleLabel: {
          display: true,
          labelString: ''
        }
      }]
    },
    legend: {
      usePointStyle: true,
      display: true,
      labels: {
        fontSize: 12,
      },
      onClick: function (event, legendItem) {
        const index = legendItem.datasetIndex;
        document.getElementById('showHiddenData_' + index).click();
      },
      // onClick: this.mainBarChartClicked,
    },
  };
  public barChartColours: Array<any> = [
    { // Series B
      backgroundColor: Color('#4e99af').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#ed956f').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#2f7347').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#8a6641').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#0f6d7c').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#f84e5d').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#0c3f51').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#4875b4').alpha(0.8).rgbString(),
      borderWidth: 1
    },
    { // Series B
      backgroundColor: Color('#b4b2ad').alpha(0.8).rgbString(),
      borderWidth: 1
    }
  ];

  hasData = false;
  htmlRight = '';

  constructor() {
    console.log(this.dataReport);
  }

  ngOnInit(): void {
    this.visualize();
  };

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport);
    this.visualize();
  }

  visualize() {    
    let data = this.dataReport.data ? this.dataReport.data.data : null;
    this.htmlRight = this.dataReport.data ? this.dataReport.data.htmlRight : '';
    let columnLabels = [];
    let chartData = [];
    let fbChartData = {
      data: [],
      label: 'Facebook'
    };
    let newsChartData = {
      data: [],
      label: 'News'
    };
    let youtubeChartData = {
      data: [],
      label: 'Youtube'
    };
    let tiktokChartData = {
      data: [],
      label: 'Tiktok'
    };
    let instagramChartData = {
      data: [],
      label: 'Instagram'
    };
    let linkedinChartData = {
      data: [],
      label: 'Linkedin'
    };



    let fbText = {
      brandCount: 0,
      topBrand: '',
      topPropotion: '0'
    };
    let newsText = {
      brandCount: 0,
      topBrand: '',
      topPropotion: '0'
    };

    for (const key of Object.keys(data)) {
      console.log(data[key]);
      columnLabels.push(key);      
      const fbCount = data[key].statistic.docTypesCount.facebook.doc_count;
      const newsCount = data[key].statistic.docTypesCount.news.doc_count;
      const youtubeCount = data[key].statistic.docTypesCount.youtube.doc_count;
      const tiktokCount = data[key].statistic.docTypesCount.tiktok.doc_count;
      const instagramCount = data[key].statistic.docTypesCount.instagram.doc_count;
      const linkedinCount = data[key].statistic.docTypesCount.linkedin.doc_count;
      let total = fbCount + newsCount + youtubeCount + tiktokCount + instagramCount + linkedinCount;

      let fbPercentage = (fbCount / total * 100).toFixed(2);
      let newsPercentage = (newsCount / total * 100).toFixed(2);

      let youtubePercentage = (youtubeCount / total * 100).toFixed(2);
      let tiktokPercentage = (tiktokCount / total * 100).toFixed(2);
      let instagramPercentage = (instagramCount / total * 100).toFixed(2);
      let linkedinPercentage = (linkedinCount / total * 100).toFixed(2);

      fbChartData.data.push(fbPercentage);
      newsChartData.data.push(newsPercentage);
      tiktokChartData.data.push(tiktokPercentage);
      youtubeChartData.data.push(youtubePercentage);
      instagramChartData.data.push(instagramPercentage);
      linkedinChartData.data.push(linkedinPercentage);
      fbText.brandCount++;
      if(Number(fbPercentage) > Number(fbText.topPropotion)) {
        fbText.topPropotion = fbPercentage;
        fbText.topBrand = key;
      }
      newsText.brandCount++;
      if(Number(newsPercentage) > Number(newsText.topPropotion)) {
        newsText.topPropotion = newsPercentage;
        newsText.topBrand = key;
      }
    }
    chartData.push(fbChartData);
    chartData.push(newsChartData);
    chartData.push(youtubeChartData);
    chartData.push(tiktokChartData);
    chartData.push(instagramChartData);
    chartData.push(linkedinChartData);

    this.barChartLabels = columnLabels;
    this.barChartData = chartData;
    this.hasData = true;
  }


}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/compare-source/compare-source.component.ts